import React from "react";

const FormBuilderConfigLayout = ({ heading, children }) => {
    return <>
        <h5 className={"fw-bold"}>{heading}</h5>
        {children}
    </>
}

export default FormBuilderConfigLayout